import {
  Loading,
  UpdateUserForm,
  UpdateUserFormProps,
  UserFormProps,
  useOrgUser,
} from '@cibo/profile'
import { useParamAsInteger } from '@cibo/ui'
import { Box } from '@mui/material'
import { StatusCodes } from 'http-status-codes'
import { FullScreenError } from '../../consts/Theme'

export const UserProfile = ({
  userFormProps,
}: {
  userFormProps?: Omit<UpdateUserFormProps, 'userId'> & UserFormProps
}) => {
  const orgUserId = useParamAsInteger('userId')

  const user = useOrgUser(orgUserId)

  if (!orgUserId) {
    return <FullScreenError status={StatusCodes.NOT_FOUND} />
  }

  if (!!user.isInitialLoading) {
    return <Loading />
  }

  return (
    <Box sx={{ maxWidth: 960 }}>
      <UpdateUserForm {...userFormProps} userId={orgUserId} />
    </Box>
  )
}
